export const graphLineAlarm = 0xff0000;

export const colorPalette = [
  '#8181ff',
  '#171da9',
  '#537bff',
  '#92c3fd',
  '#0d4688',
  '#014791',
  '#a0c4e7',
  '#00a1ff',
  '#09b4ff',
  '#84c8ef',
];

// Colorblind-safe, based on the Okabe-Ito qualitative palette.
const contrastPalette = [
  '#0072b2',
  '#e69f00',
  '#009e73',
  '#cc79a7',
  '#d55e00',
  '#56b4e9',
  '#8c6d31',
  '#7b3294',
  '#4d4d4d',
  '#c7a600',
];

const warmPalette = [
  '#b02418',
  '#e8590c',
  '#f0a202',
  '#8c3503',
  '#d64550',
  '#a13d63',
  '#c96a1b',
  '#7d2e46',
  '#e07a5f',
  '#5c2018',
];

const naturePalette = [
  '#1b6b3a',
  '#7a9e2f',
  '#0f7b8a',
  '#b58b00',
  '#3d5a3d',
  '#4a9d5f',
  '#8a6a3a',
  '#2a7f9e',
  '#a3b545',
  '#5c4033',
];

export type GraphPaletteKey = 'default' | 'contrast' | 'warm' | 'nature';

export const GRAPH_PALETTES: Record<GraphPaletteKey, string[]> = {
  default: colorPalette,
  contrast: contrastPalette,
  warm: warmPalette,
  nature: naturePalette,
};

export const GRAPH_PALETTE_KEYS: GraphPaletteKey[] = [
  'default',
  'contrast',
  'warm',
  'nature',
];

export const DEFAULT_GRAPH_PALETTE_KEY: GraphPaletteKey = 'default';

export const getGraphPalette = (key: GraphPaletteKey | undefined): string[] =>
  GRAPH_PALETTES[key as GraphPaletteKey] ||
  GRAPH_PALETTES[DEFAULT_GRAPH_PALETTE_KEY];
